<template>
    <i :class="iconName" :style="style"></i>
</template>

<script>

import "bootstrap-icons/font/bootstrap-icons.css";

export default {
    name: "b-icon",
    props: {
        icon: { type: String },
        fontScale: { type: String, default: null },
        variant: { type: String },
        cssClass: { type: String, default: ""},
    },
    computed: {
        iconName: function() {
            return "b-icon bi bi-" + this.icon + " " + this.cssClass;
        },
        style: function() {
            if (this.fontScale) {
                return "font-size: " + (100 * this.fontScale) + "%"
            }

            return "";
        }
    }
};
</script>

<style lang="scss">
.b-icon {
    display: inline-block;
    overflow: visible;
}
</style>
